import {put, takeLatest, call} from 'redux-saga/effects';
import * as promotionService from "../../../../services/promotionService.js";
import {
    DELETE_PROMOTIONS,
    DELETE_PROMOTIONS_SUCCESS,
    DELETE_PROMOTIONS_ERROR
}
    from "../../../actions/menu/promotions";

function* deletePromotionsSaga(action) {
    try {
        yield call(promotionService.DeletePromotions, action.payload)
        
        yield put({
            type: DELETE_PROMOTIONS_SUCCESS,
            payload: action.payload._ids
        });

    } catch (error) {
        yield put({
            type: DELETE_PROMOTIONS_ERROR,error: error.data
        });
    }
}


export function* deletePromotionsSagaWatcher() {
    yield takeLatest(DELETE_PROMOTIONS, deletePromotionsSaga);
}